import { defineMessages } from 'react-intl'

export default defineMessages({
  unitPrice: {
    id: 'unitPrice',
    defaultMessage: '',
  },
  promotionalPrice: {
    id: 'promotionalPriceDetail',
    defaultMessage: '',
  },
  promotionalLabel: {
    id: 'promotional',
    defaultMessage: '',
  },
  giftLabel: {
    id: 'gift',
    defaultMessage: '',
  },
  freePrice: {
    id: 'freePriceLabelUnits',
    defaultMessage: '',
  },
})
